import { useState } from "react";
import PropTypes from "prop-types";

import GridCheckbox from "../ui/checkbox/GridCheckbox";

// Function for rendering the checkbox column
const RenderGridCheckboxColumn = ({
  rowData,
  col,
  rowIndex,
  onColumnDataChange,
  onEditRow,
  onRowEditCancel
}) => {

  const [value] = useState(rowData[col.fieldName]);
  const { colSettings, fieldName } = col;
  const isDisabled = colSettings?.isDisabled || !colSettings?.allowEdit || false;

  const handleCheckboxChange = (e) => {
    if (!e) return;

    const newValue = e.target.checked;
    // Create a new object with the updated checkbox value
    const updatedData = {
      ...rowData,
      [fieldName]: newValue
    };

    // Call onColumnDataChange with the new value
    col.colSettings?.allowGridToEditMode && newValue
      ? onEditRow(rowIndex, updatedData)
      : onRowEditCancel(rowIndex)

    if (onColumnDataChange) {
      onColumnDataChange(fieldName, updatedData, rowIndex);
    }
  };

  return (
    <GridCheckbox
      type="checkbox"
      checked={value}
      disabled={isDisabled}
      onChange={handleCheckboxChange}
    />
  );
};

RenderGridCheckboxColumn.propTypes = {
  rowData: PropTypes.object.isRequired,
  col: PropTypes.shape({
    colSettings: PropTypes.object,
    fieldName: PropTypes.string.isRequired
  }).isRequired,
  rowIndex: PropTypes.number.isRequired,
  onColumnDataChange: PropTypes.func,
  onEditRow: PropTypes.func,
  onRowEditCancel: PropTypes.func,

};

export default RenderGridCheckboxColumn